// eslint-disable-next-line import/prefer-default-export
export const MODES = {
  MONOLOGUE: 'monologue',
  SCENE: 'scene',
};
